



















export default {
  props: ['language', 'paymentManDay', 'todoCount', 'todoManday'],
};

